<template>
    <router-view/>
</template>
<script>
export default {
    name: 'ProductPage',
}
</script>